module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYBAMAAAAMkBB4AAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADnRSTlMAESIzRFVmd4iZqrvM3UwhkGcAAACYSURBVBjTY2Dw3Q0BVxgYGEoZICAciFugbA8g3sDiAgIO3CA2ezkIFIDZUDVANnMDlM1hwMBakA5WU8YewMDuYALW68xSwMCpAFXDNAGkBQo2MHCzQd2QsIFBCi6+kMEdzi5hSIOz0xhqIK4Fuvw4UIYhHcguYwCqBrJlBBgYD0LZzJsZrA2gbAbN3ZMYYGwIwM2u2Q0DxwFlEDZCoR1H0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/serv.png
// module id = 650
// module chunks = 0